export default __webpack_public_path__ + "static/media/login-logo.f3974665.svg";